module.exports = __webpack_public_path__ + "assets/images/misc.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/misc.png
// module id = 403
// module chunks = 1